import React from 'react';
import { Controller } from 'react-hook-form';
import "./index.scss";

const Radio = ({ 
    onInputChange=undefined, 
    name, 
    rules, 
    required=true, 
    disabled=false, 
    control, 
    errors,
    className="",
    label="",
    checked=false,
    value:data="",
}) => {
  return (
    <div className={`form-check ${className ? className : ""}`}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <input 
            className="form-check-input" 
            type="radio" 
            name={name}
            required={required}
            disabled={disabled}
            id={label} 
            value={data} 
            checked={value === data} 
            onChange={(e) => {
              onChange(e);
              if(onInputChange){
                onInputChange(e);
              }
            }}
          />
        )}
      />
      {label && <label className="form-check-label" htmlFor={label}>
        {label}
      </label>}
      {errors && errors[name] && (
        <div className="invalid-feedback">
          {errors[name]?.message}
        </div> 
      )}
    </div>
  );
}

export default Radio;
